module.exports = __webpack_public_path__ + "img/11.76c9c37b.png";